import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-field-listing', {
    mixins: [AppListing]
});